import React from 'react'
import useOptions from './useOptions'
import Select from 'UI/Select'

const Filters = ({
  filters,
  setFilters,
  customers
}) => {
  const { loading, options } = useOptions(customers)

  const handleFilter = (name, value) => {
    setFilters(state => ({...state, [name]: value || []}))
  }

  return (
    <div className="mb-4 text-sm leading-none">
      <div className="flex mb-2">
        <div className="mr-4 w-80">
          <label>Customers</label>
          <Select
            isMulti
            value={filters.customers}
            options={options.customers}
            onChange={value => handleFilter('customers', value)}
          />
        </div>

        <div className="mr-4 w-80">
          <label>Storage Policy</label>
          <Select
            isMulti
            value={filters.storagePolicies}
            options={options.storagePolicies}
            onChange={value => handleFilter('storagePolicies', value)}
          />
        </div>

        <div className="mr-4 w-80">
          <label>Location</label>
          <Select
            isMulti
            value={filters.locations}
            options={options.locations}
            onChange={value => handleFilter('locations', value)}
          />
        </div>

        <div className="mr-4 w-80">
          <label>Commcell</label>
          <Select
            isMulti
            value={filters.commcells}
            options={options.commcells}
            onChange={value => handleFilter('commcells', value)}
          />
        </div>
      </div>

      <div className="flex">
        <div className="mr-4 w-80">
          <label>Subclient</label>
          <Select
            isMulti
            isLoading={loading.subclient}
            isDisabled={loading.subclient}
            value={filters.subclients}
            options={options.subclients}
            onChange={value => handleFilter('subclients', value)}
          />
        </div>

        <div className="mr-4 w-80">
          <label>Job Type</label>
          <Select
            isMulti
            isLoading={loading.jobType}
            isDisabled={loading.jobType}
            value={filters.jobTypes}
            options={options.jobTypes}
            onChange={value => handleFilter('jobTypes', value)}
          />
        </div>

        <div className="mr-4 w-80">
          <label>Status</label>
          <Select
            isMulti
            isLoading={loading.status}
            isDisabled={loading.status}
            value={filters.statuses}
            options={options.statuses}
            onChange={value => handleFilter('statuses', value)}
          />
        </div>

        <div className="mr-4 w-80">
          <label>Out of schedule</label>
          <Select
            value={filters.outOfShcedule}
            isClearable
            options={options.outOfSchedule}
            onChange={value => handleFilter('outOfSchedule', value)}
          />
        </div>
      </div>
    </div>
  )
}

export default Filters